export const EMPLOYEE_ROLES = {
    driver: 'DRIVER',
    helper: 'HELPER'
}


// WEBPACK FOOTER //
// ./src/app/contants/EMPLOYEE_ROLES.ts